import * as yup from 'yup';

import { createCreditCardValidationSchema } from '@chargify/payments-sdk';
import { createAddressValidationSchema } from '@chargify/address';

/**
 * Creates payment profile validation schema
 * @param {string[]} requiredFields - collection of required field
 * @returns validation schema
 */
export const serializeValidationSchema = (requiredFields: string[]) =>
  yup.object({
    paymentMethod: createCreditCardValidationSchema(requiredFields),
    billingAddress: createAddressValidationSchema(requiredFields),
  });
